/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { scroller } from 'react-scroll';

import { Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import type { UpsellsByDegreeSlug } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

const styles = {
  root: css`
    padding: 24px;
    background-color: var(--cds-color-white-0);
    border: 1px solid #e5e7e8;
  `,
  courseLink: css`
    font-size: 16px;
    font-weight: 700;
  `,
  button: css`
    color: var(--cds-color-blue-700);
    background-color: transparent;
    border: none;
    padding: 0;
    margin-top: 16px;
    font-size: 16px;
    font-weight: 700;
    text-decoration: underline;
  `,
  learnMoreLink: css`
    margin-top: 16px;
  `,
  logo: css`
    width: 52px;
    height: 53px;
    position: relative !important;
    margin-right: 9px;
  `,
  logoSection: css`
    margin-top: 19px;
    display: flex;
    align-items: center;
  `,
  nextIcon: css`
    color: var(--cds-color-blue-700);
    margin-left: 12.4px;
  `,
};

type Props = {
  stackableItems?: UpsellsByDegreeSlug;
};

const handleScrollToStackabilityInfoBanner = () => {
  scroller.scrollTo('xddpStackabilityInfoScrollerAnchor', {
    smooth: true,
    offset: -150,
  });
};

const renderSingleStackableCourse = (stackableItem?: UpsellsByDegreeSlug) => {
  if (!stackableItem || !stackableItem[0]) return null;

  return (
    <div data-testid="single-stackability-sidebar">
      <div>
        <Typography2 component="p" variant="bodyPrimary" display="inline">
          {_t(
            'Get a head start on your degree studies by earning a certificate from one of these participating programs.'
          )}
        </Typography2>
      </div>
      <div className="m-t-2">
        <TrackedButton role="button" onClick={handleScrollToStackabilityInfoBanner} css={styles.button}>
          {_t('Learn more')}
        </TrackedButton>
      </div>
    </div>
  );
};

const renderMultipleStackableCourse = () => {
  return (
    <div data-testid="multiple-stackability-sidebar">
      <Typography2 component="p" variant="bodyPrimary">
        {_t('Get a head start on your degree with courses, specializations or certificates.')}
      </Typography2>
      <TrackedButton role="button" onClick={handleScrollToStackabilityInfoBanner} css={styles.button}>
        {_t('Learn more')}
      </TrackedButton>
    </div>
  );
};

const StackabilitySidebarInfo: React.FC<Props> = ({ stackableItems }) => {
  if (!stackableItems?.length) return null;
  const upsellLength = stackableItems?.length;
  return (
    <div css={styles.root} data-testid="stackability-side-bar">
      {upsellLength > 1 ? renderMultipleStackableCourse() : renderSingleStackableCourse(stackableItems)}
    </div>
  );
};
export default StackabilitySidebarInfo;
